<template>
  <div class="keydown-result">
    <ul class="search-result-list">
      <AutoKeywordRow
        v-for="keyword in keywords"
        :key="keyword"
        :keyword="keyword"
        :shwrd="shwrd"
        @select="(keyword) => emits('select', keyword)"
      />
    </ul>
  </div>
</template>
<script setup>
import {
  onMounted,
  defineProps,
  inject,
  ref,
  watch,
  computed,
  defineEmits,
} from "vue";
import { api } from "@/plugins/api";
import Utils from "@/js/utils";
import AutoKeywordRow from "@/components/paintpro/prod/searchAutoKeywordListRow.vue";

const emits = defineEmits(["select"]);

const url = inject("url_prefix");

const props = defineProps({
  shwrd: {
    type: String,
    default: "",
  },
});

const keywords = ref([]);
const searchable = ref(true);
const searchedWord = ref("");
const currSearchWord = ref("");

onMounted(() => {
  currSearchWord.value = props.shwrd;
  search();
});

const shwrd = computed(() => {
  return props.shwrd;
});

watch(shwrd, () => {
  currSearchWord.value = props.shwrd;
  search();
});

const search = () => {
  if (searchable.value) {
    if (currSearchWord.value !== searchedWord.value) {
      loadAutoKeywordList();
      searchedWord.value = currSearchWord.value;
      searchable.value = false;

      setTimeout(() => {
        searchable.value = true;
        search();
      }, 500);
    }
  }
};

const loadAutoKeywordList = async () => {
  if (Utils.isBlank(currSearchWord.value)) return;

  const res = await api.post(`${url}/agency/search/autoKeywords`, {
    shwrd: currSearchWord.value.trim(),
  });

  const { resultCode } = res;
  if (resultCode !== 200) {
    //alert(`errror : resultCode:${resultCode}, message:${message} `);
    return;
  }

  keywords.value = res.data;
};
</script>
